import { Link } from "react-router-dom";
import { Burger } from "../Burger/Burger";

import { RoutesEnum } from "../../../../shared/constants/routes";
import { classNames } from "../../../../shared/lib/classNames";
import { LogoThirtyYears } from "../../../../shared/assets/svg";
import { Theme } from "../../types/theme";
import { NavigationList } from "../NavigationList";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { Container } from "../../../../shared/ui";

import type { FC } from "react";

import styles from "./Header.module.scss";
import { NavigationVacancies } from "../NavigationVacancies";

interface HeaderProps {
    theme?: Theme;
}

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.md);

export const Header: FC<HeaderProps> = ({ theme = "standard" }) => {
    const isMobile = useMediaQuery(mediaQuery);

    return (
        <header className={styles.header}>
            <Container
                className={classNames({
                    cls: styles.wrapper,
                    additional: [styles[`header_${theme}`]],
                })}
                marginSize="standard"
            >
                <div className={styles.navigationWrapper}>
                    <Link className={styles.logoLink} to={RoutesEnum.Home}>
                        <LogoThirtyYears className={styles.logo} />
                    </Link>
                    {!isMobile && <NavigationList />}
                </div>
                {isMobile ? <Burger /> : <NavigationVacancies />}
            </Container>
        </header>
    );
};
